import Choices from "choices.js";

/**
 * Choices JS - styles <select> menus
 * @uses https://github.com/Choices-js/
 * @returns {void}
 */
const choicesJs = () => {
  const elements = [...document.querySelectorAll(".gfield_select, .js-year-filter")];

  if (!elements) {
    return;
  }

  elements.forEach((el) => {
    const choices = new Choices(el, {
      searchEnabled: false,
      placeholder: false,
      position: 'bottom',
      shouldSort: false
    });
  });

};
choicesJs();

